import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
// import { Feature } from '../../interfaces/feature';
// import { Epic } from '../../interfaces/epic';
import { Annotation } from "../../interfaces/annotation";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-annotation-canvas-annotation",
  templateUrl: "./annotation-canvas-annotation.component.html",
  styleUrls: ["./annotation-canvas-annotation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnotationCanvasAnnotationComponent {
  env: any = environment;
  @Input() annotationVersion: number;
  @Input() annotation: Annotation;
  @Input() variant: any;
  @Input() variantIndex: number;
  @Input() featureName: string;
  @Input() variantBenefit: number;
  @Input() featureEpicId: number;
  @Input() epics: Array<Annotation>;
  @Output() itemClicked: EventEmitter<number> = new EventEmitter<number>(); //<Annotation>();
  @Output()
  deleteClicked: EventEmitter<Annotation> = new EventEmitter<Annotation>();
  @Input() isBeingEstimated: boolean;
  @Input() allVariantIndex: number;

  constructor() {}

  itemCardClicked() {
    this.itemClicked.emit(this.allVariantIndex);
  }

  annotationDeleteClicked() {
    // this.deleteClicked.emit(this.annotation);
    this.deleteClicked.emit(this.variant);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/annotation-canvas-annotation/annotation-canvas-annotation.component.ts